import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { ShopService } from '../shop.service';
import { Title }     from '@angular/platform-browser';
import * as _ from 'lodash';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';


@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  public product;
  public loading:boolean;
  public addingToCart:boolean;
  public sizes:[string];
  public colors:[string];
  public selectedColor:string;
  public selectedSize:string;
  public availableSizes:[string];
  public message:string;
  private variants:[any];
  public selectedImg:string;
  public error:string;
  public schema:object;
  

  addToCart(id:string):void {
    let self = this;

    this.addingToCart = true;
    let arr = [
      {variantId: id, quantity: 1}
    ];
    this.shop.addToCart(arr).then((resp)=>{
      this.addingToCart = false;
      self.message = `Your item has been added to your cart...`;

      setTimeout(function () {
        self.message = null;
      }, 2000);
      // this.message = `Your item has been added to your cart...`;

      //this.message = null;
      //do something
    }).catch((err)=>{
      console.error(err);
      this.addingToCart = false;
      self.error = "There was a problem adding this item to the cart...";

      setTimeout(function () {
        self.error = null;
      }, 2000);
      //display error
    });
  }

  setMessage(message:string):void {
    this.message = message;
  }

  selectColor(color:string):void {

    if (color === this.selectedColor) {
      if (this.colors.length > 1) {
        this.selectedColor = null;
        this.selectedSize = null;
      }
      
    } else {
      this.selectedColor = color;
      this.availableSizes = this.getSizes(color);
      this.selectedSize = null;
    }
     

  }

  private getSizes(color):[string]{
    return _.filter(this.variants, (v)=>{
      return !_.isUndefined(v) && v.selectedOptions[1].value === color;
    });
  }

  selectSize(size:string):void {
    
    if (this.selectedSize === size) {
      this.selectedSize = null;
    } else {
      this.selectedSize = size;

    }
  }

  availableVariants():[string] {
    let color = this.selectedColor;
    let variants = _.filter(this.product.variants, function (v) {
      return !!(_.find(v.selectedOptions, (o)=> (o.name === 'Color' && o.value === color)));
    });
    return variants;
  }

  getSize(v) {
    let sizeObj = _.filter(v.selectedOptions, (o)=> o.name === 'Size');
    return sizeObj ? sizeObj.value : null;
  }

  getProduct(): void {
    this.loading = true;
    const id = this.route.snapshot.paramMap.get('id'); 

    if (isPlatformBrowser(this.platformId)) {
      this.shop.getProduct(id).then((product)=>{
        if (product) {
          this.product = product;
          this.titleService.setTitle(product.title + " -- Bender Hardware Shop");
          if (product.images && product.images.length > 0) {
            this.selectedImg = product.images[0].src;
          }
          if (product.variants && product.variants.length > 0 && product.variants[0].title !== 'Default Title') {
            // let sizes = [];
            this.variants = _.filter(product.variants, (v)=>v.available);
            // this.colors = _.uniq(_.map(this.variants, 'selectedOptions[1].value'));
            
            this.colors = _.map(product.options[1].values, 'value');
            if (this.colors && this.colors.length === 1) {
              this.selectColor(this.colors[0]);
            }
            
          }
          this.schema = setSchema(product);
          

          this.loading = false;
        }
        
      }).catch((err)=>{
        this.loading = false;
        console.error(err);
      }); 
    } else {
      this.shop.getProductServerside(id).subscribe((product)=>{
        if (product) {
          this.product = product;
          this.titleService.setTitle(product.title + " -- Bender Hardware Shop");
          if (product.images && product.images.length > 0) {
            this.selectedImg = product.images[0].src;
          }
          if (product.variants && product.variants.length > 0 && product.variants[0].title !== 'Default Title') {
            // let sizes = [];
            this.variants = _.filter(product.variants, (v)=>v.available);
            // this.colors = _.uniq(_.map(this.variants, 'selectedOptions[1].value'));
            
            this.colors = _.map(product.options[1].values, 'value');
            if (this.colors && this.colors.length === 1) {
              this.selectColor(this.colors[0]);
            }
            
          }

          this.schema = setSchema(product);

          this.loading = false;
        }
        
      });
    }
    
    
  }

  

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private route: ActivatedRoute, private shop:ShopService, private titleService: Title) { }

  ngOnInit(): void {

    this.getProduct();
  }
  
  

  
}


function setSchema (product) {
  let schema:any = {
    "@context": "http://schema.org",
    "@id": '#' + product.id,
    "@type": "IndividualProduct",
    "description": product.description,
    "name": product.title,
    "brand": product.vendor,
    "category": product.productType,
    "url": "https://www.benderhardware.com/products/" + product.handle,
    "offers": {
      "@type": "Offer",
      "availability": "http://schema.org/InStock",
      "price": product.variants[0].price,
      "priceCurrency": "USD",
      "url": "https://www.benderhardware.com/products/" + product.handle
    }
  };
  if (product.images && product.images.length > 0) {
    schema.image = product.images[0].src;
  }
  return schema;
}


// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/product/product.component.ts